import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../../utils/immutable";
import { IAction } from "../../../../models/Action";
import { STATE_IDENTIFIER } from "./constants";
import { compose } from "redux";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";

const {
  TEMPLATE_TICKET,
  TEMPLATE_TICKET_FIELDS,
  SERVICE_REQ,
  SERVICE_REQ_FIELDS,
  EXTERNAL_FIELDS,
  FIELDS_TYPE,

  TEMPLATE_T_DEL_STATE,
  TEMPLATE_T_ADD_EDIT_STATE,
  TEMPLATE_T_FIELDS_DEL_STATE,
  TEMPLATE_T_FIELDS_ADD_EDIT_STATE,
  SERVICE_REQ_DEL_STATE,
  SERVICE_REQ_ADD_EDIT_STATE,
  SERVICE_REQ_FIELDS_DEL_STATE,
  SERVICE_REQ_FIELDS_ADD_EDIT_STATE,
  EXTERNAL_FIELDS_DEL_STATE,
  EXTERNAL_FIELDS_ADD_EDIT_STATE,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_FIELDS_TYPE_SUCCESS]: (state: any, action: any) => {
    const mappedRes = action.payload.fieldsType.map(
      (field: any) => field.fieldType
    );
    return immutableSet([FIELDS_TYPE], mappedRes, state);
  },
  [actionTypes.GET_FIELDS_TYPE_FAILURE]: (state: any, action: any) =>
    immutableSet([FIELDS_TYPE], [], state),

  [actionTypes.GET_TEMPLATE_T_SUCCESS]: (state: any, action: any) =>
    immutableSet([TEMPLATE_TICKET], action.payload.templatesTicket, state),
  [actionTypes.GET_TEMPLATE_T_FAILURE]: (state: any, action: any) =>
    immutableSet([TEMPLATE_TICKET], [], state),

  [actionTypes.POST_TEMPLATE_T_SUCCESS]: (state: any, action: any) => {
    if (action.payload.insertOrUpdateInError.length > 0)
      return immutableSet(
        [TEMPLATE_T_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
    else if (
      action.payload.insertOrUpdateInError.length === 0 &&
      action.payload.insertOrUpdateSuccess.length > 0
    )
      return immutableSet(
        [TEMPLATE_T_ADD_EDIT_STATE],
        IResponseState.SUCCESS,
        state
      );
    else
      return immutableSet(
        [TEMPLATE_T_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
  },
  [actionTypes.POST_TEMPLATE_T_FAILURE]: (state: any, action: any) =>
    immutableSet([TEMPLATE_T_ADD_EDIT_STATE], IResponseState.ERROR, state),

  [actionTypes.DELETE_TEMPLATE_T_SUCCESS]: (state: any, action: any) => {
    if (action.payload.deleteInError.length > 0)
      return immutableSet(
        [TEMPLATE_T_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
    else if (
      action.payload.deleteInError.length === 0 &&
      action.payload.deleteSuccess.length > 0
    )
      return immutableSet(
        [TEMPLATE_T_DEL_STATE],
        IResponseState.SUCCESS,
        state
      );
    else
      return immutableSet(
        [TEMPLATE_T_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
  },
  [actionTypes.DELETE_TEMPLATE_T_FAILURE]: (state: any, action: any) =>
    immutableSet([TEMPLATE_T_DEL_STATE], IResponseState.ERROR, state),

  [actionTypes.GET_TEMPLATE_FIELDS_SUCCESS]: (state: any, action: any) => {
    let data: {
      idTemplate: string;
      fieldName: string;
      fieldValue: string;
      uniqueId: string;
    }[] = [];
    action.payload.templatesField.forEach(
      (d: { idTemplate: any; fieldName: any; fieldValue: string }) =>
        data.push({ ...d, uniqueId: `${d.idTemplate}-${d.fieldName}` })
    );
    return immutableSet([TEMPLATE_TICKET_FIELDS], data, state);
  },
  [actionTypes.GET_TEMPLATE_FIELDS_FAILURE]: (state: any, action: any) =>
    immutableSet([TEMPLATE_TICKET_FIELDS], [], state),

  [actionTypes.POST_TEMPLATE_FIELDS_SUCCESS]: (state: any, action: any) => {
    if (action.payload.insertOrUpdateInError.length > 0)
      return immutableSet(
        [TEMPLATE_T_FIELDS_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
    else if (
      action.payload.insertOrUpdateInError.length === 0 &&
      action.payload.insertOrUpdateSuccess.length > 0
    )
      return immutableSet(
        [TEMPLATE_T_FIELDS_ADD_EDIT_STATE],
        IResponseState.SUCCESS,
        state
      );
    else
      return immutableSet(
        [TEMPLATE_T_FIELDS_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
  },
  [actionTypes.POST_TEMPLATE_FIELDS_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [TEMPLATE_T_FIELDS_ADD_EDIT_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.DELETE_TEMPLATE_FIELDS_SUCCESS]: (state: any, action: any) => {
    if (action.payload.deleteInError.length > 0)
      return immutableSet(
        [TEMPLATE_T_FIELDS_DEL_STATE],
        IResponseState.ERROR,
        state
      );
    else if (
      action.payload.deleteInError.length === 0 &&
      action.payload.deleteSuccess.length > 0
    )
      return immutableSet(
        [TEMPLATE_T_FIELDS_DEL_STATE],
        IResponseState.SUCCESS,
        state
      );
    else
      return immutableSet(
        [TEMPLATE_T_FIELDS_DEL_STATE],
        IResponseState.ERROR,
        state
      );
  },
  [actionTypes.DELETE_TEMPLATE_FIELDS_FAILURE]: (state: any, action: any) =>
    immutableSet([TEMPLATE_T_FIELDS_DEL_STATE], IResponseState.ERROR, state),

  [actionTypes.GET_SERV_SUCCESS]: (state: any, action: any) => {
    let data: any[] = [];
    action.payload.forEach((rs: any) =>
      data.push({
        serviceRequestId: rs.serviceRequestId,
        serviceRequestName: rs.serviceRequestName,
        displayOrder: rs.displayOrder,
        provisioning: `${rs.flag}`,
        flag: rs.flag,
      })
    );
    return immutableSet([SERVICE_REQ], data, state);
  },
  [actionTypes.GET_SERV_FAILURE]: (state: any, action: any) =>
    immutableSet([SERVICE_REQ], [], state),

  [actionTypes.POST_SERV_SUCCESS]: (state: any, action: any) => {
    if (action.payload.insertOrUpdateInError.length > 0)
      return immutableSet(
        [SERVICE_REQ_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
    else if (
      action.payload.insertOrUpdateInError.length === 0 &&
      action.payload.insertOrUpdateSuccess.length > 0
    )
      return immutableSet(
        [SERVICE_REQ_ADD_EDIT_STATE],
        IResponseState.SUCCESS,
        state
      );
    else
      return immutableSet(
        [SERVICE_REQ_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
  },
  [actionTypes.POST_SERV_FAILURE]: (state: any, action: any) =>
    immutableSet([SERVICE_REQ_ADD_EDIT_STATE], IResponseState.ERROR, state),

  [actionTypes.DELETE_SERV_SUCCESS]: (state: any, action: any) => {
    if (action.payload.deleteInError.length > 0)
      return immutableSet([SERVICE_REQ_DEL_STATE], IResponseState.ERROR, state);
    else if (
      action.payload.deleteInError.length === 0 &&
      action.payload.deleteSuccess.length > 0
    )
      return immutableSet(
        [SERVICE_REQ_DEL_STATE],
        IResponseState.SUCCESS,
        state
      );
    else
      return immutableSet([SERVICE_REQ_DEL_STATE], IResponseState.ERROR, state);
  },
  [actionTypes.DELETE_SERV_FAILURE]: (state: any, action: any) =>
    immutableSet([SERVICE_REQ_DEL_STATE], IResponseState.ERROR, state),

  [actionTypes.GET_SERV_FIELDS_SUCCESS]: (state: any, action: any) => {
    let data: any[] = [];
    action.payload.fields.forEach((f: any) =>
      data.push({ ...f, uniqueId: `${f.idServiceRequest}-${f.idField}` })
    );
    return immutableSet([SERVICE_REQ_FIELDS], data, state);
  },
  [actionTypes.GET_SERV_FIELDS_FAILURE]: (state: any, action: any) =>
    immutableSet([SERVICE_REQ_FIELDS], [], state),

  [actionTypes.POST_SERV_FIELDS_SUCCESS]: (state: any, action: any) => {
    if (action.payload.insertOrUpdateInError.length > 0)
      return immutableSet(
        [SERVICE_REQ_FIELDS_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
    else if (
      action.payload.insertOrUpdateInError.length === 0 &&
      action.payload.insertOrUpdateSuccess.length > 0
    )
      return immutableSet(
        [SERVICE_REQ_FIELDS_ADD_EDIT_STATE],
        IResponseState.SUCCESS,
        state
      );
    else
      return immutableSet(
        [SERVICE_REQ_FIELDS_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
  },
  [actionTypes.POST_SERV_FIELDS_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [SERVICE_REQ_FIELDS_ADD_EDIT_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.DELETE_SERV_FIELDS_SUCCESS]: (state: any, action: any) => {
    if (action.payload.deleteInError.length > 0)
      return immutableSet(
        [SERVICE_REQ_FIELDS_DEL_STATE],
        IResponseState.ERROR,
        state
      );
    else if (
      action.payload.deleteInError.length === 0 &&
      action.payload.deleteSuccess.length > 0
    )
      return immutableSet(
        [SERVICE_REQ_FIELDS_DEL_STATE],
        IResponseState.SUCCESS,
        state
      );
    else
      return immutableSet(
        [SERVICE_REQ_FIELDS_DEL_STATE],
        IResponseState.ERROR,
        state
      );
  },
  [actionTypes.DELETE_SERV_FIELDS_FAILURE]: (state: any, action: any) =>
    immutableSet([SERVICE_REQ_FIELDS_DEL_STATE], IResponseState.ERROR, state),

  [actionTypes.GET_EXTERNAL_FIELDS_SUCCESS]: (state: any, action: any) =>
    immutableSet([EXTERNAL_FIELDS], action.payload.fieldExternalList, state),
  [actionTypes.GET_EXTERNAL_FIELDS_FAILURE]: (state: any, action: any) =>
    immutableSet([EXTERNAL_FIELDS], [], state),

  [actionTypes.POST_EXT_FIELDS_SUCCESS]: (state: any, action: any) => {
    if (action.payload.insertOrUpdateInError.length > 0)
      return immutableSet(
        [EXTERNAL_FIELDS_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
    else if (
      action.payload.insertOrUpdateInError.length === 0 &&
      action.payload.insertOrUpdateSuccess.length > 0
    )
      return immutableSet(
        [EXTERNAL_FIELDS_ADD_EDIT_STATE],
        IResponseState.SUCCESS,
        state
      );
    else
      return immutableSet(
        [EXTERNAL_FIELDS_ADD_EDIT_STATE],
        IResponseState.ERROR,
        state
      );
  },
  [actionTypes.POST_EXT_FIELDS_FAILURE]: (state: any, action: any) =>
    immutableSet([EXTERNAL_FIELDS_ADD_EDIT_STATE], IResponseState.ERROR, state),

  [actionTypes.DELETE_EXT_FIELDS_SUCCESS]: (state: any, action: any) => {
    if (action.payload.deleteInError.length > 0)
      return immutableSet(
        [EXTERNAL_FIELDS_DEL_STATE],
        IResponseState.ERROR,
        state
      );
    else if (
      action.payload.deleteInError.length === 0 &&
      action.payload.deleteSuccess.length > 0
    )
      return immutableSet(
        [EXTERNAL_FIELDS_DEL_STATE],
        IResponseState.SUCCESS,
        state
      );
    else
      return immutableSet(
        [EXTERNAL_FIELDS_DEL_STATE],
        IResponseState.ERROR,
        state
      );
  },
  [actionTypes.DELETE_EXT_FIELDS_FAILURE]: (state: any, action: any) =>
    immutableSet([EXTERNAL_FIELDS_DEL_STATE], IResponseState.ERROR, state),

  [actionTypes.RESET_SERVICE_REQ_ADMIN_STATE]: (state: any, action: any) =>
    compose(
      immutableSet([TEMPLATE_T_DEL_STATE], IResponseState.PENDING),
      immutableSet([TEMPLATE_T_ADD_EDIT_STATE], IResponseState.PENDING),
      immutableSet([TEMPLATE_T_FIELDS_DEL_STATE], IResponseState.PENDING),
      immutableSet([TEMPLATE_T_FIELDS_ADD_EDIT_STATE], IResponseState.PENDING),
      immutableSet([SERVICE_REQ_DEL_STATE], IResponseState.PENDING),
      immutableSet([SERVICE_REQ_ADD_EDIT_STATE], IResponseState.PENDING),
      immutableSet([SERVICE_REQ_FIELDS_DEL_STATE], IResponseState.PENDING),
      immutableSet([SERVICE_REQ_FIELDS_ADD_EDIT_STATE], IResponseState.PENDING),
      immutableSet([EXTERNAL_FIELDS_DEL_STATE], IResponseState.PENDING),
      immutableSet([EXTERNAL_FIELDS_ADD_EDIT_STATE], IResponseState.PENDING)
    )(state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
